import { render } from "./Com_Pagingbar.vue?vue&type=template&id=a665dbac&scoped=true"
import script from "./Com_Pagingbar.vue?vue&type=script&lang=js"
export * from "./Com_Pagingbar.vue?vue&type=script&lang=js"

import "./Com_Pagingbar.vue?vue&type=style&index=0&id=a665dbac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a665dbac"]])

export default __exports__